<div class="dialog-wrapper">
  <span class="dialog-heading">{{ 'editProfile' | translate }}</span>
  <form (submit)="saveChanges()">
    <div class="input-fields">
      <div class="left-side">
        <mat-form-field class="example-full-width" appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'editProfileFormConfig.userName' | translate }}</mat-label>
          <input disabled matInput placeholder="+000 00 000 000" [(ngModel)]="updateClient.username" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'editProfileFormConfig.company' | translate }}</mat-label>
          <input matInput placeholder="+000 00 000 000" [(ngModel)]="updateClient.company" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="outline" [hideRequiredMarker]="true">
          <mat-label>-{{ 'editProfileFormConfig.email' | translate }}</mat-label>
          <input matInput placeholder="+000 00 000 000" [(ngModel)]="updateClient.email" disabled [ngModelOptions]="{standalone: true}">
        </mat-form-field>
      </div>
      <div class="right-side">
        <mat-form-field class="example-full-width" appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'editProfileFormConfig.address' | translate }}</mat-label>
          <input matInput placeholder="+000 00 000 000" [(ngModel)]="updateClient.address" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'editProfileFormConfig.city' | translate }}</mat-label>
          <input matInput placeholder="+000 00 000 000" [(ngModel)]="updateClient.city" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'editProfileFormConfig.phoneNumber' | translate }}</mat-label>
          <input matInput placeholder="+000 00 000 000" [(ngModel)]="updateClient.phone" [ngModelOptions]="{standalone: true}">
        </mat-form-field>
      </div>
    </div>
    <span class="dialog-heading">{{ 'changePassword' | translate }}</span>
    <div class="input-fields">
      <div class="left-side">
        <mat-form-field class="example-full-width" appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'editProfileFormConfig.oldPass' | translate }}</mat-label>
          <input [type]="visibilityPerInput('old') ? 'text' : 'password'" matInput placeholder="**************" [(ngModel)]="updateClient.oldPassword" [ngModelOptions]="{standalone: true}">
          <mat-icon matSuffix class="cursor-pointer visible-icon" (click)="toggleVisibility('old')">{{ visibilityPerInput('old') ? 'visibility' : 'visibility_off' }}</mat-icon>
        </mat-form-field>
        <mat-form-field class="example-full-width" appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'editProfileFormConfig.newPass' | translate }}</mat-label>
          <input [type]="visibilityPerInput('new') ? 'text' : 'password'" matInput placeholder="**************" [(ngModel)]="updateClient.newPassword" [ngModelOptions]="{standalone: true}">
          <mat-icon matSuffix class="cursor-pointer visible-icon" (click)="toggleVisibility('new')">{{ visibilityPerInput('new') ? 'visibility' : 'visibility_off' }}</mat-icon>
        </mat-form-field>
      </div>
      <div class="right-side">
        <div style="height: 90px"></div>
        <mat-form-field class="example-full-width" appearance="outline" [hideRequiredMarker]="true">
          <mat-label>{{ 'editProfileFormConfig.retypePass' | translate }}</mat-label>
          <input [type]="visibilityPerInput('repeat') ? 'text' : 'password'" matInput placeholder="**************" [(ngModel)]="updateClient.retypePassword" [ngModelOptions]="{standalone: true}">
          <mat-icon matSuffix class="cursor-pointer visible-icon" (click)="toggleVisibility('repeat')">{{ visibilityPerInput('repeat') ? 'visibility' : 'visibility_off' }}</mat-icon>
        </mat-form-field>
      </div>
    </div>
    <button class="save-changes-button">
      <img [src]="localImages.saveChangesIcon" alt="">
      <span class="save-changes-text" type="submit">{{ 'saveChanges' | translate }}</span>
    </button>
  </form>
</div>
